module.exports = __webpack_public_path__ + "img/phase1-2013-05.af0c3f11.jpg";